import { render, staticRenderFns } from "./EnterTask.vue?vue&type=template&id=a263a4e4&scoped=true&"
import script from "./EnterTask.vue?vue&type=script&lang=js&"
export * from "./EnterTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a263a4e4",
  null
  
)

export default component.exports